<template>
    <v-row class="fiscalContactForm">
        <!--<div class="d-flex align-center">
            <v-card-subtitle class="font-weight-bold">
                ¿Deseas utilizar los mismos datos con los que te registraste en la ventanilla?
            </v-card-subtitle>
            <v-switch
                v-model="useNameOfContact"
                inset
                :label="useNameOfContact ? 'Si' : 'No'"
                class="mt-0"
                @change="useProcedureContact()"
            ></v-switch>
        </div>-->
        <v-col cols="6">
          <v-text-field
              label="RFC"
              outlined required v-model="fiscalContact.rfc"
              placeholder="Ingresa una RFC válida"
              :rules="[formValidator.rfc.validate]"
              class="pb-0"
              @keyup="validateRFC()"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
              label="CURP"
              outlined required v-model="fiscalContact.curp"
              placeholder="Ingresa tu CURP"
              :rules="[formValidator.curp.validate]"
              class="pb-0"
          />
        </v-col>
        <v-col cols="12" v-if="moralPerson">
            <v-text-field
                    label="Razón Social *"
                    outlined required v-model="fiscalContact.razon_social"
                    :rules="[formValidator.input.required]"
            />
        </v-col>
        <v-col cols="4" v-if="!moralPerson">
            <v-text-field
                label="Nombre *"
                outlined required v-model="fiscalContact.nombre"
                :rules="[formValidator.input.required]"
            />
        </v-col>
        <v-col cols="4" v-if="!moralPerson">
            <v-text-field
                label="Apellido Paterno *"
                outlined required v-model="fiscalContact.apellido_pat"
                :rules="[formValidator.input.required]"
            />
        </v-col>
        <v-col cols="4" v-if="!moralPerson">
            <v-text-field
                label="Apellido Materno"
                outlined required v-model="fiscalContact.apellido_mat"
            />
        </v-col>
      <v-col cols="6">
        <v-text-field v-if="validRFC"
                      label="Teléfono *"
                      outlined required v-model="fiscalContact.telefono"
                      :rules="[formValidator.input.required]"
        />
        <v-text-field v-else
                      label="Teléfono"
                      outlined required v-model="fiscalContact.telefono"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field v-if="validRFC"
                      label="Email *"
                      outlined required
                      v-model="fiscalContact.email"
                      :rules="[formValidator.input.required]"
        />
        <v-text-field v-else
                      label="Email"
                      outlined required
                      v-model="fiscalContact.email"
        />
      </v-col>



        <v-col cols="6">
            <v-select
                :items="states"
                item-value="cve_agee"
                item-text="nom_agee"
                v-model="fiscalContact.estado_id"
                label="Estado:"
                required
                outlined
                @change="onStateSelectChange()"
            ></v-select>
        </v-col>
        <v-col cols="6">
            <v-select
                :items="municipalities"
                item-value="cve_agem"
                item-text="nom_agem"
                v-model="fiscalContact.municipio_id"
                label="Municipio:"
                required
                outlined
                @change="onMunicipalitySelectChange()"
            ></v-select>
        </v-col>

      <v-col cols="6">
        <v-select
            :items="neighborhoods"
            item-value="nom_asen"
            item-text="nom_asen"
            v-model="fiscalContact.colonia"
            label="Colonia:"
            required
            outlined
        ></v-select>
      </v-col>
      <v-col cols="6">
        <v-text-field
            label="Localidad:"
            outlined required v-model="fiscalContact.localidad"
        />
      </v-col>
        <v-col cols="6">
            <v-text-field
                label="Código Postal:"
                outlined required v-model="fiscalContact.codigo_postal"
            />
        </v-col>
      <v-col cols="6">
        <v-text-field
            label="Calle"
            outlined required v-model="fiscalContact.calle"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
            label="Num Exterior:"
            outlined required v-model="fiscalContact.no_ext"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
            label="Num Interior:"
            outlined required v-model="fiscalContact.no_int"
        />
      </v-col>

        <v-col cols="12" v-if="validRFC">
            <v-select
                    v-model="fiscalContact.uso_cfdi"
                    :items="cfdiUses"
                    item-text="label"
                    item-value="id"
                    label="Uso CFDI *"
                    outlined
                    :rules="[formValidator.input.required]"
            ></v-select>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "FiscalContactFormEdit",
    props: [
        'fiscalContact', 'formValidator', 'states', 'municipalities', 'neighborhoods',
        'getMunicipalitiesCatalog', 'getNeighborhoodsCatalog', 'useProcedureContact'
    ],
    data(){
        return {
            formValid: false,
            useNameOfContact: false,
            validRFC: false,
            moralPerson: false,
            cfdiUses: []
        }
    },

    mounted() {
        this.validateRFC()

    },

    methods: {
        onStateSelectChange(){
            this.fiscalContact.municipio_id = ''
            this.fiscalContact.colonia = ''
            this.getMunicipalitiesCatalog(this.fiscalContact.estado_id)
        },

        onMunicipalitySelectChange(){
            this.fiscalContact.colonia = ''
            this.getNeighborhoodsCatalog(this.fiscalContact.estado_id, this.fiscalContact.municipio_id)
        },

        onChangeUseContact(){

        },

        validateRFC(){
            this.validRFC = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/.test(this.fiscalContact.rfc.toUpperCase())

            if (this.validRFC){
                this.moralPerson = this.fiscalContact.rfc.length === 12
                this.setCFDIUses()

                if (this.moralPerson){
                    this.fiscalContact.nombre = ""
                    this.fiscalContact.apellido_pat = ""
                    this.fiscalContact.apellido_mat = ""
                }else {
                    this.fiscalContact.razon_social = ""
                }
            }
        },

        setCFDIUses(){
            let cfdiUses = [
                {"id": "G01", "label": "Adquisición de mercancias",},
                {"id": "G02", "label": "Devoluciones, descuentos o bonificaciones"},
                {"id": "G03", "label": "Gastos en general"},
                {"id": "I01", "label": "Construcciones",},
                {"id": "I02", "label": "Mobilario y equipo de oficina por inversiones"},
                {"id": "I03", "label": "Equipo de transporte"},
                {"id": "I04", "label": "Equipo de computo y accesorios"},
                {"id": "I05", "label": "Dados, troqueles, moldes, matrices y herramental"},
                {"id": "I06", "label": "Comunicaciones telefónicas"},
                {"id": "I07", "label": "Comunicaciones satelitales"},
                {"id": "I08", "label": "Otra maquinaria y equipo"},
            ]

            let moralCfdiUses = [
                {"id": "D01", "label": "Honorarios médicos, dentales y gastos hospitalarios."},
                {"id": "D02", "label": "Gastos médicos por incapacidad o discapacidad"},
                {"id": "D03", "label": "Gastos funerales."},
                {"id": "D04", "label": "Donativos."},
                {"id": "D05", "label": "Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)."},
                {"id": "D06", "label": "Aportaciones voluntarias al SAR."},
                {"id": "D07", "label": "Primas por seguros de gastos médicos."},
                {"id": "D08", "label": "Gastos de transportación escolar obligatoria."},
                {"id": "D09", "label": "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones."},
                {"id": "D10", "label": "Pagos por servicios educativos (colegiaturas)"},
            ]

            let bothCfdiUses = [
                {"id": "P01", "label": "Por definir"}
            ]

            if (this.moralPerson){
                this.cfdiUses =  [...cfdiUses, ...bothCfdiUses]
            }else{
                this.cfdiUses = [...cfdiUses, ...moralCfdiUses, ...bothCfdiUses]
            }
        }
    }
}

/**/
</script>

<style>
    .fiscalContactForm .v-messages {display: none}
</style>